import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requirePermission } from '~/utils/guards';

const AbacUsersPage = lazy(() => import('~/features/organization/pages/abac-users-page'));

export const Route = createFileRoute('/_authenticated/_tenant/subsidiary/access-control')({
  beforeLoad: requirePermission('organization_abac_users'),
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <AbacUsersPage />
    </Suspense>
  ),
});
